import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import { FieldCaption, FieldTooltip, RadioGroupRoot, Root } from '../styles';
const RadioInput = (props) => {
    const { id, value, values, caption, tooltip, size = 'small', big = false, direction = 'column', onChange } = props;
    const onValueChange = (val) => () => {
        if (onChange) {
            onChange(val);
        }
    };
    return (_jsxs(Root, { size: size, style: { margin: '0 5px' }, children: [_jsx(FieldCaption, { children: caption }), _jsx(RadioGroupRoot, { column: direction === 'column', children: values?.map((item, idx) => (_jsx(FormControlLabel, { value: item.value, control: _jsx(Radio, { color: "primary", size: big ? 'medium' : 'small' }), label: item.text, name: id, checked: item.value === value, onChange: onValueChange(item.value) }, idx.toString()))) }), _jsx(FieldTooltip, { children: tooltip })] }));
};
export default RadioInput;
//# sourceMappingURL=RadioInput.js.map